import { gql, useQuery } from '@apollo/client'

export const getBlogConfig = gql`
  query getBlogConfig {
    getBlogConfig {
      meta_title
      meta_keywords
      meta_description
    } 
  }
`

interface Response {
  getBlogConfig: {
    meta_title?: string
    meta_keywords?: string
    meta_description?: string
  }
}

export const useBlogConfig = () => {
  const { data, loading, error } = useQuery(getBlogConfig)
  const config: Response = data

  return {
    config,
    loading,
    error
  }
}
